<template>
  <nav class="menu">
    <p class="menu-label">Settings</p>
    <ul class="menu-list">
      <li>
        <router-link :to="{ name: 'MeetingSettings' }">
          General Settings
        </router-link>
      </li>
    </ul>
    <p class="menu-label">Schedule</p>
    <ul class="menu-list">
      <li>
        <router-link
          :to="{ name: 'MeetingDashboard', params: { id: meeting.id } }"
          exact
          >Appointment Times</router-link
        >
      </li>
    </ul>

    <p class="menu-label">Contacts</p>
    <ul class="menu-list">
      <li>
        <router-link :to="{ name: 'ManageRetailers' }"
          >Manage Retailers</router-link
        >
      </li>
      <li>
        <router-link :to="{ name: 'ManageSuppliers' }"
          >Manage Suppliers</router-link
        >
      </li>
      <li>
        <router-link :to="{ name: 'ManageServiceProviders' }"
          >Manage Service Providers</router-link
        >
      </li>
    </ul>

    <p class="menu-label">Export</p>
    <ul class="menu-list">
      <li>
        <button @click.prevent="runUsersExport">
          Retailers, Suppliers, and Service Providers
        </button>
      </li>
      <li><button @click.prevent="runScheduleExport">Schedules</button></li>
      <li>
        <router-link :to="{ name: 'SummaryReportBuilder' }"
          >Summary Report</router-link
        >
      </li>
    </ul>

    <p class="menu-label">Reports</p>
    <ul class="menu-list">
      <li>
        <router-link :to="{ name: 'ViewFullSchedule' }"
          >View Full Schedule</router-link
        >
      </li>
      <li>
        <router-link :to="{ name: 'PrintableSchedules' }"
          >Printable Schedules</router-link
        >
      </li>
    </ul>

    <p class="menu-label">Status</p>
    <ul class="menu-list">
      <li>
        <button
          class="button block is-small flex mt-2"
          v-if="currentPhase.advanceText"
          @click="advancePhase()"
        >
          <span class="icon"><i class="fas fa-cog"></i></span>
          <span>{{ currentPhase.advanceText }}</span>
        </button>
      </li>
      <li>
        <button class="button block is-small flex" @click="toggleArchived()">
          <span class="icon"><i class="fas fa-folder-open"></i></span>
          <span>{{ meeting.is_archived ? 'Unarchive' : 'Archive' }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import eventHub from '@/event-hub';

export default {
  props: {
    pageId: {
      type: String,
      required: true,
      default: null
    },
    meeting: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    currentPhase: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  methods: {
    runScheduleExport() {
      eventHub.$emit('runScheduleExport');
    },
    advancePhase() {
      eventHub.$emit('advancePhase');
    },
    runUsersExport() {
      eventHub.$emit('runUsersExport');
    },
    toggleArchived() {
      eventHub.$emit('toggleArchived');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/meeting/MeetingMenu.vue